import { SELECTEC_SIDE_CONTENT_ATTENDANCE } from "../constants/ActionTypes";

export const sideContentAttendanceSelected = (selected) => {
  return {
    type: SELECTEC_SIDE_CONTENT_ATTENDANCE,
    selected,
  };
};
